import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    EditButton,
    ShowButton,
    DeleteButton,
    TopToolbar,
    SearchInput,
    SelectInput,
    useGetList,
    ReferenceField,
    FunctionField,
} from 'react-admin';
import { Card, Typography, Box, Chip } from '@mui/material';
import {
    Dashboard as DashboardIcon,
} from '@mui/icons-material';


import CustomCreateButton from '../../components/CustomCreateButton.tsx';
import RoleIconField from '@/components/RoleIconField.tsx';
const DashboardGroupListActions = () => (
    <TopToolbar
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            display: 'block',
        }}
    >
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'flex-start', sm: 'flex-end' },
                justifyContent: 'space-between',
                width: '100%',
                p: 1,
                px: 0,
                mt: 1,
            }}
        >
            <CustomCreateButton
                label="Crear Grupo"
                variant="contained"
                sx={{
                    marginTop: { xs: 2, sm: 0 },
                    alignSelf: 'flex-end',
                }}
            />
        </Box>
    </TopToolbar>
);

const DashboardGroupsList = () => {
    const { data: plants } = useGetList('plants', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'plantName', order: 'ASC' },
        filter: {},
    });

    const plantChoices =
        plants?.map((plant: any) => ({
            id: plant.id,
            name: plant.plantName || plant.name || `Planta ${plant.id}`,
        })) || [];

    const dashboardGroupFilters = [
        <SearchInput
            key='search'
            source='q'
            alwaysOn={true}
            placeholder='Buscar grupos...'
            size='small'
            sx={{
                minWidth: 200,
                mb: 0.5
            }}
        />,
        <SelectInput
            key='plant'
            alwaysOn
            source='plantId'
            label='Planta'
            choices={plantChoices}
        />,
    ];

    return (
        <Card elevation={1} sx={{ m: 2, p: 2 }}>
            <Box
                sx={{ p: 3, pt: 2, pb: 2.5, borderBottom: 1, borderColor: 'divider' }}
            >
                <Typography
                    variant='h5'
                    component='h1'
                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <DashboardIcon color='primary' />
                    Gestión de Grupos de Dashboard
                </Typography>
            </Box>
            <List
                title={false}
                actions={<DashboardGroupListActions />}
                filters={dashboardGroupFilters}
                perPage={25}
                sort={{ field: 'position', order: 'ASC' }}
                sx={{ '& .RaList-main': { mt: 0 } }}
            >
                <Datagrid
                    rowClick='show'
                    sx={{ '& .RaDatagrid-headerCell': { fontWeight: 'bold' } }}
                >
                    <TextField source='id' label='ID' />
                    <TextField source='groupName' label='Nombre del Grupo' />
                    <NumberField source='position' label='Posición' />
                    <ReferenceField
                        source='plantId'
                        reference='plants'
                        label='Planta'
                        link='show'
                    >
                        <TextField source='plantName' />
                    </ReferenceField>
                    <FunctionField
                        label='Roles y Permisos'
                        render={(record: any) => <RoleIconField record={record} />}
                    />
                    <ShowButton label={false} />
                    <EditButton label={false} />
                    <DeleteButton label={false} />
                </Datagrid>
            </List>
        </Card>
    );
};

export default DashboardGroupsList;
